/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { EnergyUsageResponse, GetEnergyUsageV2Params } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve an accounts energy usage, across a given period, aggregated to a given value.
 */
export const getEnergyUsageV2 = (
  accountId: number,
  params: GetEnergyUsageV2Params,
  options?: SecondParameter<typeof backofficeRequest<EnergyUsageResponse>>,
) => {
  return backofficeRequest<EnergyUsageResponse>(
    { url: `/api/v2/accounts/${accountId}/energyUsage`, method: "GET", params },
    options,
  )
}
export type GetEnergyUsageV2Result = NonNullable<
  Awaited<ReturnType<typeof getEnergyUsageV2>>
>
